import { useState } from "react";

const useSearchedStudentField = ({ foundStudentList, studentReservations }) => {
	const [searchedStudent, setSearchedStudent] = useState("");
	const changeSearchedStudent = studentName => {
		foundStudentList.clear();
		setSearchedStudent(studentName);
		if (!studentName) return;
		foundStudentList.fill(studentReservations, studentName);
	};
	return {
		value: searchedStudent,
		change: changeSearchedStudent,
	};
};

export default useSearchedStudentField;
